import { CheckmarkDoneCheck4Icon } from '@qitech/icons';
import { useThemeContext } from '../../../../contexts/ThemeContext';
import { PoweredByQITech } from '../components/PoweredByQITech';
import { resolveColor } from '../../theme/utils/resolveColor';
import * as S from './styles';

interface SignedPageProps {
    signData: any;
}

export const CardsSignedPage = ({
    signData,
}: SignedPageProps) => {
    const { clientThemeSettings } = useThemeContext();

    const accentColor = resolveColor('text', clientThemeSettings) || '#0e3573';

    const isIOS = (/iPhone|iPad|iPod/i.test(navigator.userAgent));

    const governmentAppStoreUrl = signData.signature_settings?.government_app_store_url;
    const governmentGooglePlayUrl = signData.signature_settings?.government_google_play_url;
    const governmentStoreUrl = isIOS ? governmentAppStoreUrl : governmentGooglePlayUrl;
    const hasGovernmentApp = Boolean(governmentStoreUrl);

    return (
        <S.PageWrapper>
            <S.ScrollContent>
                <S.Header>
                    {clientThemeSettings?.logo_url && (
                        <S.LogoImage src={clientThemeSettings.logo_url} alt="logo" />
                    )}
                </S.Header>

                <S.HeroSection>
                    <S.CheckIconWrapper $color={accentColor}>
                        <CheckmarkDoneCheck4Icon size={80} />
                    </S.CheckIconWrapper>

                    {hasGovernmentApp ? (
                        <>
                            <S.Title $accentColor={accentColor}>
                                Falta pouco!<br />Agora precisamos da sua <strong>anuência</strong>
                            </S.Title>
                            <S.Description>
                                Para liberar o desconto do cartão na sua folha de pagamento, acesse o
                                aplicativo SouGov.br e autorize a contratação.
                            </S.Description>
                            {isIOS ? (
                                <S.GovernmentStoreBadge
                                    src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                                    alt="Baixar SouGov.br na App Store"
                                    onClick={() => window.open(governmentStoreUrl, '_blank')}
                                />
                            ) : (
                                <S.GovernmentStoreBadge
                                    src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                                    alt="Baixar SouGov.br no Google Play"
                                    onClick={() => window.open(governmentStoreUrl, '_blank')}
                                />
                            )}
                        </>
                    ) : (
                        <>
                            <S.Title $accentColor={accentColor}>
                                Falta muito pouco para você começar a aproveitar todos os{' '}
                                <strong>benefícios do seu novo cartão.</strong>
                            </S.Title>
                            <S.Description>
                                Sua solicitação já está em análise. Em breve entraremos em contato com você.
                            </S.Description>
                        </>
                    )}
                </S.HeroSection>
            </S.ScrollContent>

            <S.AppBannerSection $accentColor={accentColor}>
                <S.BannerContent>
                    <S.BannerTextGroup>
                        <S.BannerTitle>Baixe o aplicativo</S.BannerTitle>
                        <S.BannerDescription>
                            <strong>Acompanhe a entrega</strong> e realize a ativação do seu cartão.
                        </S.BannerDescription>
                    </S.BannerTextGroup>
                    {isIOS ? (
                        <S.StoreBadge
                            src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                            alt="Download on the App Store"
                            onClick={() => signData.signature_settings.app_store_url && window.open(signData.signature_settings.app_store_url, '_blank')}
                        />
                    ) : (
                        <S.StoreBadge
                            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                            alt="Get it on Google Play"
                            onClick={() => signData.signature_settings.google_play_url && window.open(signData.signature_settings.google_play_url, '_blank')}
                        />
                    )}
                </S.BannerContent>

                <S.PoweredByWrapper>
                    <PoweredByQITech />
                </S.PoweredByWrapper>
            </S.AppBannerSection>
        </S.PageWrapper>
    );
};
